import MistakeLessonList from './MistakeLessonList';

import { withRouter } from 'react-router-dom';

export default withRouter(MistakeLessonList);
